import dayjs from "dayjs";
import type { Travel } from "../../getTravel";
import { UserBaggageIcon } from "./UserBaggageIcon";

type Props = {
  review: Travel["reviews"][number];
};
export const Review = ({ review }: Props) => {
  return (
    <div className="bg-[#FCF6F0] rounded-lg border border-[#F4EAE1] py-4 px-3 w-full">
      <div className="flex space-x-3">
        <div className="bg-white rounded-full border-2 border-[#F4EAE1] p-[10px]">
          <UserBaggageIcon />
        </div>
        <div className="flex flex-col justify-center">
          <p className="text-base leading-5 font-bold">
            {review.firstname} {review.lastname}.
          </p>
          <p className="text-xs leading-[14px] text-[#C1B1AC] capitalize mt-0.5">
            {dayjs(review.date).format("MMMM YYYY")}
          </p>
        </div>
      </div>
      <p className="text-sm mt-3">{review.text}</p>
    </div>
  );
};
